var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDrops(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4766 2.38633C7.3089 1.96133 6.01775 2.5634 5.59274 3.7311L2.3863 12.5407C1.9613 13.7084 2.56337 14.9996 3.73107 15.4246L5.74156 16.1563V10.2418C5.74156 7.96359 7.58839 6.11677 9.86656 6.11677H18.1091C17.8836 5.89066 17.6061 5.70921 17.2862 5.59277L8.4766 2.38633ZM9.68491 7.99899C8.52721 8.09148 7.61656 9.06028 7.61656 10.2418V16.8388L7.61664 16.8388L7.61664 19.6168C7.61664 20.8594 8.624 21.8668 9.86664 21.8668H19.2416C20.4843 21.8668 21.4916 20.8594 21.4916 19.6168V10.2418C21.4916 8.99912 20.4843 7.99176 19.2416 7.99176H9.86664C9.80959 7.99176 9.75304 7.99388 9.69706 7.99805C9.693 7.99836 9.68895 7.99867 9.68491 7.99899ZM14.5541 10.2877L15.7029 13.7805L19.1958 14.9293L15.7029 16.078L14.5541 19.5709L13.4054 16.078L9.91252 14.9293L13.4054 13.7805L14.5541 10.2877Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrops);
export default __webpack_public_path__ + "static/media/icon-drops.6c3e5dde06e5a2acfc25ea1919ca51ae.svg";
export { ForwardRef as ReactComponent };